import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { BuNameService } from "../../helper/core/bu-name.service";
import { Constant } from "../../helper/core/constant";
import { CoreService } from "../../helper/core/core.service";
import { AppState } from "../../store";
import {
  toggleModalFilterMobile,
  toggleModalHelp,
} from "../../store/filter/filter.action";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  public errorMsg: string;
  public buName: string;
  public buUrl: string;
  public buImg: string;
  public displayHeader: boolean;
  public isHeaderEvent: boolean = false;
  public isVoluntary: boolean = false;
  public showModalSearch: boolean = false;
  public filters$: Observable<any>;
  public errorApiContact: string = "";
  public validApiContact: string = "";
  public contactForValues: any = [];
  public buSlug: string;
  public bu: any = false;
  public showTheme: any = false;
  public arrayThemes: any = []

  helpLastname: FormControl;
  helpFirstname: FormControl;
  helpEmail: FormControl;
  helpTelephone: FormControl;
  helpReason: FormControl;
  helpMessage: FormControl;
  helpContactFor: FormControl;
  helpTheme: FormControl;
  helpForm: FormGroup;

  constructor(
    private buNameService: BuNameService,
    private route: ActivatedRoute,
    private router: Router,
    private builder: FormBuilder,
    private constant: Constant,
    private coreService: CoreService,
    private titleService: Title,
    private store: Store<AppState>
  ) {}

  ngOnInit() {

    this.contactForValues = [
      {id: 0, label: "Annuler un atelier"},
      {id: 1, label: "M’inscrire sur liste d’attente"},
      {id: 2, label: "Avoir des informations sur le déroulé d’un atelier"},
      {id: 3, label: "Autre"}
    ];

    // Affichage du nom de la BU
    this.buNameService.buName$.subscribe(data => {
      
      if(data.name.length > 0){
        this.isHeaderEvent = true;
      } 
      if(window.location.pathname === "/voluntary"){
        this.isVoluntary = true;
      }
      this.buName = data.name;
      if (this.buName === "" && window.location.pathname === "/voluntary") {
        this.buName = "Salarié volontaire"
      }
      this.buUrl = data.url;
      this.buImg = data.img;
    });

    $(document).ready(function () {
      $(document).foundation();
    });

    // Création du formulaire d'aide
    this.helpLastname = new FormControl("", [
      Validators.required,
      Validators.pattern(this.constant.namePattern),
    ]);

    this.helpFirstname = new FormControl("", [
      Validators.required,
      Validators.pattern(this.constant.namePattern),
    ]);

    this.helpEmail = new FormControl("", [
      Validators.required,
      Validators.pattern(this.constant.emailPattern),
    ]);

    this.helpTelephone = new FormControl("", [
      Validators.pattern(this.constant.mobilePattern),
    ]);

    
    this.helpContactFor = new FormControl("", [Validators.required]);

    this.helpTheme = new FormControl("");

    this.helpMessage = new FormControl("", [Validators.required]);

    // Enregistrement du formulaire
    this.helpForm = this.builder.group({
      lastname: this.helpLastname,
      firstname: this.helpFirstname,
      email: this.helpEmail,
      telephone: this.helpTelephone,
      message: this.helpMessage,
      contactFor: this.helpContactFor,
      theme: this.helpTheme,
    });

    this.displayHeader = this.coreService.inIframe();
    this.filters$ = this.store.pipe(select("filter"));

    setTimeout(() => {
      if (this.buUrl) {
        this.getEventsThemes(this.buUrl)
      }
    }, 400);
    
  }

  private getEventsThemes(buSlug) {
    this.arrayThemes = [];
    this.coreService.getEvents(buSlug).subscribe(
      (data) => {
        if(data.onlineWorkshop){
          data.onlineWorkshop.forEach(el => {
            this.arrayThemes.push(el.title)
          });
        }
        
        if(data.physicalWorkshop){
          data.physicalWorkshop.forEach(el => {
            this.arrayThemes.push(el.title)
          });
        }

        if(data.spotlight){
          this.arrayThemes.push(data.spotlight.title)
        }
        
      }, (dataError) => {
        
      });
  }

  toggleModalFilterMobile() {
    this.store.dispatch(toggleModalFilterMobile());
  }

  toggleModalHelp(bool: boolean) {
    this.store.dispatch(toggleModalHelp());
  }

  public goToSearch(value) {
    if (window.matchMedia("(min-width: 64rem)").matches) {
      this.router.navigate(["/" + this.buUrl + "/search"], {
        queryParams: { query: value },
      });
      this.titleService.setTitle(value);
    } else {
      this.showModalSearch = true;
    }
  }

  public goToSearchMobile(value) {
    this.router.navigate(["/" + this.buUrl + "/search"], {
      queryParams: { query: value },
    });
    this.titleService.setTitle(value);
    this.showModalSearch = false;
  }

  toggleModalSearchMobile() {
    this.showModalSearch = false;
  }

  changeContactFor(value) {
    const preFill = "Date : \r\nHeure : ";
    this.helpForm.controls['contactFor'].setValue(value)
    if (value === this.contactForValues[0]) {
      this.helpForm.get('theme').setValidators([Validators.required])
      this.helpForm.get('theme').updateValueAndValidity();
      this.helpMessage.setValue(preFill);
      this.showTheme = true;
    } else if(value === this.contactForValues[1]) {
      this.helpForm.get('theme').setValidators([Validators.required])
      this.helpForm.get('theme').updateValueAndValidity();
      this.helpMessage.setValue("");
      this.showTheme = true;
    } else {
      this.helpForm.get('theme').clearValidators()
      this.helpForm.get('theme').updateValueAndValidity();
      this.helpMessage.setValue("");
      this.showTheme = false;
    }
  }

  changeTheme(value) {
    
  }

  onSubmitFormHelp() {
    this.errorApiContact = "";
    this.validApiContact = "";

    let obj: any = {
      firstName: this.helpForm.value.firstname,
      lastName: this.helpForm.value.lastname,
      email: this.helpForm.value.email,
      phone: this.helpForm.value.telephone,
      message: this.helpForm.value.message,
      contactFor: this.helpForm.value.contactFor.id
    };

    //Si annuler un atelier ou inscription sur liste d'attente on ajoute au payload le theme
    if(this.showTheme) 
      obj.theme = this.helpForm.value.theme

    this.coreService.sendFormHelp(obj).subscribe(
      (data) => {
        this.validApiContact = "Merci ! Votre message a bien été envoyé.";
      },
      (dataError) => {
        this.errorApiContact =
          "Une erreur est survenue lors de l'envoi du message.";
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts